/**
 * Opções de hospital para o ComboboxSelector, buscáveis por nome, código e CNPJ.
 *
 * A regra nasceu no N114 (pedido da Alana, botão "Vincular") e estava escrita
 * só lá dentro. O N133 pediu a mesma busca na inclusão manual do escopo e o
 * N135 na conferência de lacres — três cópias da mesma lógica seria a receita
 * para uma delas divergir e a busca voltar a falhar em uma tela só.
 *
 * ⚠️ O CNPJ entra nas DUAS formas (só dígitos e formatado) de propósito. Sem
 * isso a busca falha de um jeito silencioso: quem digita "12.345" não acha um
 * cadastro salvo sem máscara, quem digita "12345" não acha um salvo com
 * máscara — e conclui que o hospital não existe no sistema.
 */

export interface HospitalBuscavel {
  id: number;
  nome: string;
  codigo?: string;
  cnpj?: string;
}

export interface OpcaoCombobox {
  id: number;
  label: string;
  subLabel?: string;
  searchValue: string;
}

/** Formata 14 dígitos como 00.000.000/0000-00. Devolve '' se não tiver 14. */
export const formatarCnpj = (valor: string): string => {
  const d = (valor || '').replace(/\D/g, '');
  if (d.length !== 14) return '';
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};

export const opcoesHospitalBuscavel = (
  hospitais: HospitalBuscavel[],
): OpcaoCombobox[] =>
  hospitais.map((h) => {
    const cnpjDigitos = (h.cnpj || '').replace(/\D/g, '');
    const cnpjFmt = formatarCnpj(cnpjDigitos);
    const partes = [h.codigo, cnpjFmt || cnpjDigitos].filter(Boolean);
    return {
      id: h.id,
      label: h.nome,
      // Mostra código e CNPJ embaixo do nome: dois hospitais com nome parecido
      // ficam distinguíveis sem ter que abrir o cadastro.
      subLabel: partes.length > 0 ? partes.join(' · ') : undefined,
      searchValue: [h.nome, h.codigo, cnpjDigitos, cnpjFmt]
        .filter(Boolean)
        .join(' '),
    };
  });
